import { Button, Box } from "@mui/material";
import SortableTable from "../../../../../App/Components/Table/SortableTable";
import Modal from "../../../../../App/Components/Modals/Modal";
import ModalForm from "../../../../../App/Components/Modals/Components/ModalForm";
import { useModalHooks } from "../../../../../App/State/Hooks/useModalHooks";
import useAbacAttributesState from "./State/AttributesState";
import { IApp } from "../../../../../App/Typings/AbacApp";
import AttributeTableCell from "./Components/AttributeTableCell";
import CreateAttributeForm from "./Components/CreateAttributeForm";

interface IAttributeProps {
  app: IApp;
}

export function Attributes({ app }: IAttributeProps) {
  const {
    getters: {
      attributes,
      columns,
      isAttributeListLoading,
      createAttributeFormTitle,
      createIsLoading,
      formik,
    },
    handlers: { handleCreateModalClose },
  } = useAbacAttributesState(app);

  const { modalStatus, openModal } = useModalHooks();

  return (
    <>
      <Box>
        <Box
          sx={{
            width: "100%",
            position: "relative",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              position: "absolute",
              right: "0px",
              top: "0px",
              left: { xs: "0px", sm: "unset" },
            }}
            onClick={() => openModal()}
          >
            Create Attribute
          </Button>
        </Box>
        <Box
          sx={{
            pt: { xs: "3rem", sm: "unset" },
          }}
        >
          <SortableTable
            columns={columns}
            tableData={attributes}
            rowComponent={AttributeTableCell}
            loading={isAttributeListLoading}
            hideSearch={false}
            defaultSortIndex={0}
            setTableData={undefined}
            reverse={false}
            customProps={undefined}
          />
        </Box>
      </Box>
      <Modal
        fullWidth
        maxWidth="sm"
        open={modalStatus.open === true}
        title={createAttributeFormTitle}
        hasLoadingBar={true}
        isProcessing={createIsLoading}
        handleClose={() => handleCreateModalClose()}
      >
        <ModalForm formik={formik} isProcessing={createIsLoading}>
          <CreateAttributeForm />
        </ModalForm>
      </Modal>
    </>
  );
}
